'use strict';

var _createClass = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _inherits = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _wrapNativeSuper = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);
  var _super = _createSuper(TimeoutError);
  function TimeoutError() {
    var _this;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Request timed out';
    _classCallCheck(this, TimeoutError);
    _this = _super.call(this, message);
    _this.name = 'TimeoutError';
    return _this;
  }
  return _createClass(TimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.TimeoutError = TimeoutError;
var AbortError = /*#__PURE__*/function (_Error2) {
  _inherits(AbortError, _Error2);
  var _super2 = _createSuper(AbortError);
  function AbortError() {
    var _this2;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The operation was aborted.';
    _classCallCheck(this, AbortError);
    _this2 = _super2.call(this, message);
    _this2.name = 'AbortError';
    return _this2;
  }
  return _createClass(AbortError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.AbortError = AbortError;
var HTTPError = /*#__PURE__*/function (_Error3) {
  _inherits(HTTPError, _Error3);
  var _super3 = _createSuper(HTTPError);
  function HTTPError(response) {
    var _this3;
    _classCallCheck(this, HTTPError);
    _this3 = _super3.call(this, response.statusText);
    _this3.name = 'HTTPError';
    _this3.response = response;
    return _this3;
  }
  return _createClass(HTTPError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.HTTPError = HTTPError;